<template>
  <div>
    <div class="content-header">
      <div class="left">经销商审核</div>
      <div class="right"></div>
      <div class="bottom">


         <div class="bottom_left">
          <p class="tag_p">
          <span class="tag" @click="tabChange(0)" :class="{active:page.mode == 0}">申请审核</span>
          <span class="tag" @click="tabChange(1)" :class="{active:page.mode == 1}">解除审核</span>
        </p>
        </div>
        <div class="bottom_right">

        <Input v-model="page.key" style="width:280px;" maxlength="11" placeholder="手机号/账号搜索"></Input>
        <Button
          type="primary"
          style="margin-left:10px;"
          icon="ios-search"
          @click="()=>{this.page.p=0;this.getData();}"
        >搜索</Button>
        <Button style="margin-left:10px;" @click="Reset()">重置</Button>
        </div>


      </div>
    </div>
   <!--  <Tabs :v-model="page.mode" @on-click="tabChange">
      <TabPane label="申请审核" name="0"></TabPane>
      <TabPane label="解除审核" name="1"></TabPane>
    </Tabs> -->
    <Table :columns="columns" :data="data">
      <template slot-scope="{ row }" slot="action">
        <Button type="primary" size="small" @click="initModal(row)" v-if="row.status === 0">审核</Button>
        <Button type="error" size="small" @click="initModal(row)" v-if="row.cancel === 1">解除</Button>
      </template>
    </Table>
    <div class="t-right t-top-10">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="total"
        show-elevator
        show-sizer
        show-total
      />
    </div>
    <Modal v-model="modal.status" :title="page.mode == 0 ? '审核提醒' : '会员属性'" width="400">
      <div style="margin:10px 0">
        审核通过后，此客户将从会员身份升级为经销商身份，并可享受店铺商品的批发价格和所有经销商活动；你也可以前往客户管理页面为此客户配置相应客户等级与支付结算方式！
      </div>
      <div slot="footer" class="drawer-footer1">
        <Button @click="modal.status = false" style="margin-right:10px">取消</Button>
        <Button type="primary" @click="save" :loading="modal.loading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
let mode = 0;
export default {
  data() {
    return {
      columns: [
        {
          title: "编号",
          key: "id",
          width: 90
        },
        {
          key: "company_name",
          title: "企业名称",
          width: 320
        },
        {
          title: "联系人",
          key: "contacts",
          width: 150
        },
        {
          title: "联系电话",
          key: "contacts_tel",
          width: 200
        },
        {
          title: "详情地址",
          key: "contacts_address",
          width: 400
        },
        {
          title: "邮箱",
          key: "email",
          width: 200
        },
        {
          title: "状态",
          key: "status",
          width: 200,
          render(h, data) {
            const arr = ["待审核", "已审核"];
            // const arr1 = ["待审核", "已审核"];
            /* if (this.page.mode === 1) {
              return h("span", {}, arr1[data.row.cancel + 1]);
            } */
            return h("span", {}, arr[data.row.status]);
          }
        },
        {
          title: "操作",
          key: "action",
          slot: "action",
          width: 130,
          fixed: "right"
        }
      ],
      data: [],
      total: 0,
      page: {
        mode: 0,
        p: 0,
        l: 10,
        key: ""
      },
      modal: {
        status: false,
        loading: false,
        data: {
          user_id: 0,
          shop_user_type_id: 0,
          id: 0
        }
      },
      typeData: []
    };
  },
  mounted() {
    this.clientType();
    this.getData();
  },
  methods: {
    ...mapActions(["GetDealerList", "getClientType", "DealerExamine"]),
    getData() {
      this.GetDealerList(this.page).then(res => {
        this.data = res.data;
        this.total = res.total;
      });
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    sizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    Reset() {
      this.page.key = "";
      this.page.p = 0;
      this.clientType();
      this.getData();
    },
    /********编辑 */
    initModal(row) {
      this.modal = {
        status: true,
        loading: false,
        data: {
          user_id: row.user_id,
          shop_user_type_id: 0,
          id: row.id,
          alias:row.company_name
        }
      };
      this.clientType();
    },
    save() {
      this.typeData.map(item=>{
        if(item.name == '注册经销商'){
          this.modal.data.shop_user_type_id = item.id
        }
      })
      let data = this.modal.data;
      data.mode = this.page.mode;
      this.DealerExamine(data).then(res => {
        if (res.status) {
          this.$Message.success(res.msg);
          this.modal.status = false;
          this.getData()
        }
      });
    },
    clientType() {
      this.getClientType({ type: this.page.mode == 1 ? 0 : 1 }).then(res => {
        this.typeData = res.data;
      });
    },
    tabChange(e) {
      this.page.mode = e;
      this.page.key = "";
      this.page.p = 0;
      this.getData();
    }
  },
  computed: mapGetters({}),
  watch: {
    mode:{}
  }
};
</script>
<style lang='less'>
.tab {
  width: 200px;
  display: flex;

  .item {
    font-size: 16px;
    margin-right: 10px;
  }
}
</style>
